:host {
  display: block;
}
/* border-2 rounded-full flex animate-spin */
.loading-main{
  border-width: 2px;
  border-radius: 50%;
  display: flex;
  animation: spin 1s linear infinite;
  border-color: var(--mainColor);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}